/* unplugin-vue-components disabled */import script from "./Xwxq.vue?vue&type=script&lang=ts&setup=true"
export * from "./Xwxq.vue?vue&type=script&lang=ts&setup=true"

import "./Xwxq.vue?vue&type=style&index=0&id=9f877bec&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f877bec"]])

export default __exports__